import { PricingPlansItem } from '@content/pricing/pricing-plans/pricing-plans.type';

export const pricingPlansItems: PricingPlansItem[] = [
    {
        title: $localize`:@@pricing-prof-pack-title-base:Base`,
        features: [
            $localize`:@@pricing-prof-pack-fn-employee:Employee time tracking`,
            $localize`:@@pricing-prof-pack-fn-activity:Activity Dashboard`,
            $localize`:@@pricing-prof-pack-fn-attachment-doc:Attachment Documents`,
            $localize`:@@pricing-prof-pack-fn-attachment-cred:Attachment Credentials`,
            $localize`:@@pricing-prof-pack-fn-attachment-links:Attachment Links`,
            $localize`:@@pricing-prof-pack-fn-clients-manage:Clients management`,
            $localize`:@@pricing-prof-pack-fn-projects-manage:Projects Management`,
            $localize`:@@pricing-prof-pack-fn-manage-holidays:Manage holidays`,
            $localize`:@@pricing-prof-pack-fn-manage-sickness:Manage sickness policy`,
            $localize`:@@pricing-prof-pack-fn-manage-work-holidays:Manage work holidays`,
            $localize`:@@pricing-prof-pack-fn-manage-work-week:Manage work week`,
        ],

        pricePerTeam: 450,
        pricePerUser: 120,
    },
    {
        title: $localize`:@@pricing-prof-pack-title-standard:Standard`,
        features: [
            $localize`:@@pricing-prof-pack-fn-all-in-base:All in base`,
            $localize`:@@pricing-prof-pack-fn-inventory:Inventory management`,
        ],
        featuresSoon: [
            $localize`:@@pricing-prof-pack-fn-soon-manage-new-vacancies:Manage new vacancies`,
            $localize`:@@pricing-prof-pack-fn-soon-manage-sales-team:Manage the sales team`,
        ],
    },
    {
        title: $localize`:@@pricing-prof-pack-title-all-features-pack:All Features Pack`,
        features: [$localize`:@@pricing-prof-pack-fn-all-in-standard:All in standard`],
        featuresSoon: [
            $localize`:@@pricing-prof-pack-fn-soon-manage-candidates:Manage candidates`,
            $localize`:@@pricing-prof-pack-fn-soon-generate-invoices:Generate invoices`,
        ],
    },
];
